import { PasskeyCredential } from '@gyym/sdk'
import { useGyymClient } from '@gyym/sdk-react'
import {
  PublicKeyCredentialCreationOptionsJSON,
  startRegistration,
} from '@simplewebauthn/browser'
import React from 'react'

import { useAuthUser } from '@/modules/Auth/hooks/useAuthUser'

/**
 * パスキーの登録セレモニー（オプション取得 → OS認証 → サーバー登録）を実行する
 */
export const usePasskeyRegistration = () => {
  const client = useGyymClient()
  const { revalidate } = useAuthUser()

  const registerPasskey = React.useCallback(async () => {
    const options =
      (await client.auth.user.createPasskeyRegisterOptions()) as unknown as PublicKeyCredentialCreationOptionsJSON

    const credential = await startRegistration({ optionsJSON: options })

    await client.auth.user.registerPasskey(
      credential as unknown as PasskeyCredential,
    )

    await revalidate()
  }, [client, revalidate])

  return { registerPasskey }
}
